import React from 'react';
import { Box, Link, Grow } from '@material-ui/core';
import useStyle from './style';

export default function BoxOptionsImage({
  display,
  photos,
  setBackgroundImage,
}) {
  const classes = useStyle();
  return (
    <Grow in={display}>
      <Box className={classes.menu}>
        {photos.map((photo) => (
          <Box
            key={photo.id}
            className={classes.box}
            style={{
              backgroundImage: `url('${photo.thumb}')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            }}
            onClick={() => setBackgroundImage(photo.url)}
          >
            <span className={classes.ownerPhoto}>
              <Link
                href={photo.user.link}
                style={{ color: '#fff' }}
                target="_blank"
              >
                {photo.user.username}
              </Link>
            </span>
          </Box>
        ))}
      </Box>
    </Grow>
  );
}
